import { create } from "zustand";

export type ThemePref = "system" | "light" | "dark";
const STORAGE_KEY = "gf-theme";

function readStored(): ThemePref {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === "light" || value === "dark" || value === "system") return value;
  } catch {
    /* almacenamiento no disponible */
  }
  return "system";
}

export function isLightActive(): boolean {
  const pref = readStored();
  if (pref !== "system") return pref === "light";
  return typeof matchMedia === "function" && matchMedia("(prefers-color-scheme: light)").matches;
}

function apply(pref: ThemePref): void {
  const root = document.documentElement;
  if (pref === "system") delete root.dataset.theme;
  else root.dataset.theme = pref;
}

interface ThemeState {
  pref: ThemePref;
  resolved: "light" | "dark";
  setPref: (pref: ThemePref) => void;
  toggle: () => void;
}

export const useTheme = create<ThemeState>((set, get) => ({
  pref: readStored(),
  resolved: isLightActive() ? "light" : "dark",
  setPref: (pref) => {
    try {
      localStorage.setItem(STORAGE_KEY, pref);
    } catch {
      /* ignorar */
    }
    apply(pref);
    set({ pref, resolved: isLightActive() ? "light" : "dark" });
  },
  toggle: () => get().setPref(isLightActive() ? "dark" : "light"),
}));

export function initTheme(): void {
  // Fuerza el tema guardado y escucha los cambios del sistema.
  const forced = new URLSearchParams(location.search).get("theme");
  if (forced === "light" || forced === "dark") {
    useTheme.getState().setPref(forced);
  } else {
    apply(useTheme.getState().pref);
  }
  if (typeof matchMedia === "function") {
    matchMedia("(prefers-color-scheme: light)").addEventListener("change", () => {
      if (useTheme.getState().pref === "system") {
        useTheme.setState({ resolved: isLightActive() ? "light" : "dark" });
      }
    });
  }
}
